<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="businessIntranet/findContactsLegalRecordList.action"
                    ref="contactsLegalListTable">
      <template slot="search">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-date-picker
                @change="onDateTimeChange"
                end-placeholder="结束日期"
                range-separator="至"
                start-placeholder="开始日期"
                type="datetimerange"
                v-model="queryParams.startEndTime">
            </el-date-picker>
          </el-col>
          <el-col :span="2">
            <el-button @click="$refs.contactsLegalListTable.search()" type="primary">搜索</el-button>
          </el-col>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column label="创建时间">
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column
            label="类型"
            prop="moduleName">
        </el-table-column>

        <el-table-column
            label="次数"
            >
          <template scope="scope">
            <span v-if="scope.row.flag=='-'" style="color: red">{{scope.row.flag}}{{scope.row.count}}</span>
            <span v-else style="color: green">{{scope.row.flag}}{{scope.row.count}}</span>

          </template>
        </el-table-column>

        <el-table-column
            label="备注"
            prop="remark">
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'contactsLegalList',
  data: function () {
    return {
      queryParams: {}
    }
  },
  created () {
    this.queryParams.businessId = this.$route.query.businessId
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.contactsLegalListTable.search()
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
